module.exports = __webpack_public_path__ + "media/images/stripe_grey-8b7834bac0a82aa5857373d077945a38.png";